import { jsx as _jsx } from "react/jsx-runtime";
import { DelimitedText, Text } from "@advosys/component-react";
export const ApproverFlowSteps = (props) => {
    if (props.steps.length === 0)
        return null;
    const items = props.steps.map(x => (_jsx(Text, { variant: "small", fontWeight: x.current ? "bold" : undefined, children: x.approverUserId })));
    return _jsx(DelimitedText, { items: items, textDelimitorString: "\u2192" });
};
